import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
export const ColorAnchor = (param)=>{
    let { size = 24, testId, style, className } = param;
    return /*#__PURE__*/ _jsxs("svg", {
        width: size,
        height: size,
        "data-testid": testId,
        style: style,
        className: className,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M17.5604 21.3749C19.9849 21.8061 23.0004 16.6465 23.0004 16.6465L17.2353 17.0296C16.4936 19.225 16.3223 20.8622 17.5604 21.3749Z",
                fill: "url(#paint0_linear_7941_14302)"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M17.6415 4.58116C17.1036 3.77754 17.295 3.69556 16.2992 3.54161C15.9831 3.49392 15.7813 2.337 12.8345 3.89242C8.89709 5.96995 2.6134 13.0792 1 15.2619L8.68163 14.7515C10.4243 12.6662 13.9123 8.75869 15.9574 7.71514C17.3129 6.7569 18.3469 5.63626 17.6415 4.58116Z",
                fill: "url(#paint1_linear_7941_14302)"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M19.5303 11.885C19.6461 11.622 19.7502 11.4229 19.8037 11.2929C20.8657 8.69459 22.0843 6.91478 20.4811 4.96959C19.3881 3.64354 16.4388 2.32839 13.928 3.38448C14.9905 3.15643 15.7941 3.23065 16.3113 4.00819C17.2198 5.37484 15.3272 8.26926 14.628 9.78062C13.8873 11.3813 13.0808 12.9601 12.5447 14.6475C12.1569 15.8701 11.8357 17.4338 12.691 18.5374C13.4317 19.4927 15.5381 20.6395 16.1242 20.8959C16.6253 21.1149 17.1618 21.3547 17.7122 21.3943C15.4663 20.4798 17.9976 15.3596 19.5303 11.885Z",
                fill: "url(#paint2_linear_7941_14302)"
            }),
            /*#__PURE__*/ _jsxs("defs", {
                children: [
                    /*#__PURE__*/ _jsxs("linearGradient", {
                        id: "paint0_linear_7941_14302",
                        x1: "13.5701",
                        y1: "19.941",
                        x2: "25.9859",
                        y2: "15.9825",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "0.18",
                                stopColor: "#4A0D73"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "0.277",
                                stopColor: "#7C2091"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "0.374",
                                stopColor: "#A731AB"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "0.461",
                                stopColor: "#C53DBD"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "0.535",
                                stopColor: "#D845C8"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "0.586",
                                stopColor: "#DF48CD"
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsxs("linearGradient", {
                        id: "paint1_linear_7941_14302",
                        x1: "20.805",
                        y1: "3.43643",
                        x2: "-2.56015",
                        y2: "29.6881",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "0.045",
                                stopColor: "#001480",
                                stopOpacity: "0.898"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "0.079",
                                stopColor: "#063194",
                                stopOpacity: "0.918"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "0.162",
                                stopColor: "#1673C1",
                                stopOpacity: "0.953"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "0.233",
                                stopColor: "#21A3E2",
                                stopOpacity: "0.976"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "0.286",
                                stopColor: "#28C1F7",
                                stopOpacity: "0.992"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "0.316",
                                stopColor: "#2BCDFF"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "0.429",
                                stopColor: "#3EDBDB"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "0.562",
                                stopColor: "#52EAB7"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "0.634",
                                stopColor: "#5AF0AA"
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsxs("linearGradient", {
                        id: "paint2_linear_7941_14302",
                        x1: "5.96662",
                        y1: "32.5044",
                        x2: "33.833",
                        y2: "19.2125",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "0.423",
                                stopColor: "#643CFF"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "0.609",
                                stopColor: "#7268FF"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "0.774",
                                stopColor: "#7D89FF"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "0.865",
                                stopColor: "#8296FF"
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
